/**
 * Click-to-activate tabbed feature ( Discover landing page ).
 *
 * One state object drives two presentations of the same items: a desktop tab
 * strip ( `activate` — one panel always open ) and a mobile accordion
 * ( `toggle` — the open panel can be closed ). The two control sets are
 * shown / hidden by breakpoint in CSS; both read and write the same `active`
 * index so switching viewports keeps the current selection.
 *
 * Usage:
 *   <div x-data="tabbedFeature( { count: 6 } )">
 *     <button x-on:click="activate( 0 )" x-bind:class="{ 'is-active': 0 === active }">…</button>
 *     <div x-show="0 === active">…</div>
 *     <button x-on:click="toggle( 0 )">…</button>
 *     <div x-show="0 === active" x-collapse>…</div>
 *   </div>
 */

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'tabbedFeature', ( config = {}) => ({

		active: 0,

		ready: false,

		count: config.count ?? 0,

		init() {
			this.ready = true;
		},

		activate( i ) {
			this.active = i;
		},

		toggle( i ) {
			this.active = this.active === i ? -1 : i;
		},

	}) );

});
